export default "__VITE_ASSET__BbZbawX7__"